"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axiosClient_1 = require("../../api/axiosClient");
const SupportedOpenshiftVersionsAPI = {
    makeBaseURI(latestRelease) {
        return `/v2/openshift-versions?only_latest=${latestRelease.toString()}`;
    },
    list(latestRelease) {
        return axiosClient_1.client.get(`${SupportedOpenshiftVersionsAPI.makeBaseURI(latestRelease)}`);
    },
};
exports.default = SupportedOpenshiftVersionsAPI;
//# sourceMappingURL=SupportedOpenshiftVersionsAPI.js.map